import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConstantsCLA } from '../shared/constants-cla';
import { SharedService } from '../shared/shared.service';

@Injectable()
export class InterceptorsService implements HttpInterceptor {
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const BASE_URL = ConstantsCLA.URL_BACK_END_CLA;

    let newReq;
    console.log('intercepted request ... ');
    if (req.url.indexOf('api') === -1) {
      return next.handle(req);
    } else if (
      (req.url.indexOf('api') === 1 || req.url.indexOf('api') === 0) &&
      req.url.indexOf('api-placement') === -1
    ) {
      const newUrl = BASE_URL + req.url;
      newReq = req.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods':
            'GET, POST, PATCH, PUT, DELETE, OPTIONS',
        }),
        url: newUrl,
      });
    }
    console.log('Sending request with new header now ...');
    return next
      .handle(newReq)
      .pipe(timeout(300000))
      .pipe(
        catchError((error, caught) => {
          // intercept the respons error and displace it to the console
          this.spinner.hide();
          console.log(error);
          this.handleAuthError(error);
          return of(error);
        }) as any
      );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 0) {
      console.log('handled error ' + err.status);
      return of(err.message);
    }
    if (err.status === 404) {
      console.log('errore 404 ' + err.status);
      return of(err.message);
    }
    if (err.status === 500) {
      this.ngxSmartModalService.getModal('addStudentProvaFinaleModal').close();
      console.log('errore 500 ' + err.message);
      const text = err.error.message;
      if(err.error.message.includes('Vuoi forzare la registrazione?')) {
        this.sharedService.openAnswerModal(text);
        this.sharedService.actionYESEvent.subscribe(
          (result) => {
            console.log(result);
            this.sharedService.setForceRegister(true);
          }
        );
      } else {
        this.sharedService.openWarningModal(text);
      }
      return of(err.message);
    }
    throw err;
  }
}
